<script setup lang="ts">
import SitePopup from '@/components/SitePopup.vue'
</script>

<template>
	<router-view />
	<SitePopup />
</template>
